var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-programa", {
                attrs: { programa: _vm.solicitud?.programa },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", [
            _vm.formularioRequerido
              ? _c("h5", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("apeironGwApp.programa.obligatorio")
                    ),
                  },
                })
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    label: _vm.$t("apeironGwApp.programa.cuota.cobra") + " *",
                    "label-for": "input-cuota-cobra",
                  },
                },
                [
                  _c("b-form-radio-group", {
                    attrs: {
                      "button-variant": "outline-danger",
                      name: "input-cuota-cobra",
                      id: "input-cuota-cobra",
                      options: _vm.options,
                      disabled: !_vm.esEscritura,
                      state: !_vm.$v.cuota.cobra.$invalid,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.reiniciarDatos()
                      },
                    },
                    model: {
                      value: _vm.cuota.cobra,
                      callback: function ($$v) {
                        _vm.$set(_vm.cuota, "cobra", $$v)
                      },
                      expression: "cuota.cobra",
                    },
                  }),
                  _vm._v(" "),
                  !_vm.$v.cuota.cobra.required
                    ? _c("small", {
                        staticClass: "text-danger",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("entity.validation.required")
                          ),
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.mostrarCampo
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label:
                          _vm.$t("apeironGwApp.programa.cuota.voluntario") +
                          (_vm.cuota.cobra ? " *" : ""),
                        "label-for": "input-cuota-voluntario",
                      },
                    },
                    [
                      _c("b-form-radio-group", {
                        attrs: {
                          "button-variant": "outline-danger",
                          name: "input-cuota-voluntario",
                          id: "input-cuota-voluntario",
                          options: _vm.options,
                          disabled: !_vm.esEscritura,
                          state: !_vm.$v.cuota.esVoluntario.$invalid,
                        },
                        model: {
                          value: _vm.cuota.esVoluntario,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuota, "esVoluntario", $$v)
                          },
                          expression: "cuota.esVoluntario",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$v.cuota.esVoluntario.required
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.required")
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.mostrarCampo
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.programa.cuota.frecuenciaColegiatura"
                        ),
                        "label-for": "input-cuota-frecuencia-colegiatura",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          name: "input-cuota-frecuencia-colegiatura",
                          id: "input-cuota-frecuencia-colegiatura",
                          state: !_vm.$v.cuota.frecuenciaColegiatura.$invalid,
                          disabled: !_vm.esEscritura,
                          options: _vm.frecuenciasCuota,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.manejarCambiaFrecuenciaColegiatura()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "first",
                              fn: function () {
                                return [
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: undefined } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.programa.cuota.seleccionarUno"
                                            )
                                            .toString()
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3065679706
                        ),
                        model: {
                          value: _vm.cuota.frecuenciaColegiatura,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuota, "frecuenciaColegiatura", $$v)
                          },
                          expression: "cuota.frecuenciaColegiatura",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$v.cuota.frecuenciaColegiatura.required
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                `${_vm.$t(
                                  "entity.validation.required"
                                )}  (${_vm.$t(
                                  "apeironGwApp.programa.cuota.seleccionarMinimoUna"
                                )})`
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mostrarCampo
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label:
                          _vm.$t(
                            "apeironGwApp.programa.cuota.montoColegiatura"
                          ) + (_vm.cuota.frecuenciaColegiatura ? " *" : ""),
                        "label-for": "input-cuota-monto-colegiatura",
                      },
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "w-100",
                        attrs: {
                          type: "number",
                          name: "input-cuota-monto-colegiatura",
                          id: "input-cuota-monto-colegiatura",
                          min: "1",
                          state: !_vm.$v.cuota.montoColegiatura.$invalid,
                          disabled: !_vm.esEscritura,
                        },
                        model: {
                          value: _vm.cuota.montoColegiatura,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuota, "montoColegiatura", _vm._n($$v))
                          },
                          expression: "cuota.montoColegiatura",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$v.cuota.montoColegiatura.required
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.required")
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.cuota.montoColegiatura.minValue
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.min", { min: 1 })
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.mostrarCampo
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.programa.cuota.frecuenciaInscripción"
                        ),
                        "label-for": "input-cuota-frecuencia-inscripcion",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          name: "input-cuota-frecuencia-inscripcion",
                          id: "input-cuota-frecuencia-inscripcion",
                          state: !_vm.$v.cuota.frecuenciaInscripcion.$invalid,
                          disabled: !_vm.esEscritura,
                          options: _vm.frecuenciasCuota,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.manejarCambiaFrecuenciaInscripcion()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "first",
                              fn: function () {
                                return [
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: undefined } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.programa.cuota.seleccionarUno"
                                            )
                                            .toString()
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3065679706
                        ),
                        model: {
                          value: _vm.cuota.frecuenciaInscripcion,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuota, "frecuenciaInscripcion", $$v)
                          },
                          expression: "cuota.frecuenciaInscripcion",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$v.cuota.frecuenciaInscripcion.required
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                `${_vm.$t(
                                  "entity.validation.required"
                                )} (${_vm.$t(
                                  "apeironGwApp.programa.cuota.seleccionarMinimoUna"
                                )})`
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mostrarCampo
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label:
                          _vm.$t(
                            "apeironGwApp.programa.cuota.montoInscripcion"
                          ) + (_vm.cuota.frecuenciaInscripcion ? " *" : ""),
                        "label-for": "input-cuota-monto-inscripcion",
                      },
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "w-100",
                        attrs: {
                          type: "number",
                          name: "input-cuota-monto-inscripcion",
                          id: "input-cuota-monto-inscripcion",
                          min: "1",
                          state: !_vm.$v.cuota.montoInscripcion.$invalid,
                          disabled: !_vm.esEscritura,
                        },
                        model: {
                          value: _vm.cuota.montoInscripcion,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuota, "montoInscripcion", _vm._n($$v))
                          },
                          expression: "cuota.montoInscripcion",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$v.cuota.montoInscripcion.required
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.required")
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.cuota.montoInscripcion.minValue
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.min", { min: 1 })
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.mostrarCampo
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.programa.cuota.frecuenciaOtraCuota"
                        ),
                        "label-for": "input-cuota-frecuencia-otra-cuota",
                      },
                    },
                    [
                      _c("b-form-select", {
                        attrs: {
                          name: "input-cuota-frecuencia-otra-cuota",
                          id: "input-cuota-frecuencia-otra-cuota",
                          state: !_vm.$v.cuota.frecuenciaOtraCuota.$invalid,
                          disabled: !_vm.esEscritura,
                          options: _vm.frecuenciasCuota,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.manejarCambiaFrecuenciaOtras()
                          },
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "first",
                              fn: function () {
                                return [
                                  _c(
                                    "b-form-select-option",
                                    { attrs: { value: undefined } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.programa.cuota.seleccionarUno"
                                            )
                                            .toString()
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3065679706
                        ),
                        model: {
                          value: _vm.cuota.frecuenciaOtraCuota,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuota, "frecuenciaOtraCuota", $$v)
                          },
                          expression: "cuota.frecuenciaOtraCuota",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$v.cuota.frecuenciaOtraCuota.required
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                `${_vm.$t(
                                  "entity.validation.required"
                                )} (${_vm.$t(
                                  "apeironGwApp.programa.cuota.seleccionarMinimoUna"
                                )})`
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.mostrarCampo
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label:
                          _vm.$t("apeironGwApp.programa.cuota.montoOtra") +
                          (_vm.cuota.frecuenciaOtraCuota ? " *" : ""),
                        "label-for": "input-cuota-monto-otra",
                      },
                    },
                    [
                      _c("b-form-input", {
                        staticClass: "w-100",
                        attrs: {
                          type: "number",
                          name: "input-cuota-monto-otra",
                          id: "input-cuota-monto-otra",
                          min: "1",
                          state: !_vm.$v.cuota.montoOtra.$invalid,
                          disabled: !_vm.esEscritura,
                        },
                        model: {
                          value: _vm.cuota.montoOtra,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuota, "montoOtra", _vm._n($$v))
                          },
                          expression: "cuota.montoOtra",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$v.cuota.montoOtra.required
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.required")
                              ),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.cuota.montoOtra.minValue
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.min", { min: 1 })
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _vm.mostrarTipoCuota
            ? _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label:
                          _vm.$t("apeironGwApp.programa.cuota.tipoCuota") +
                          (_vm.cuota.frecuenciaOtraCuota != undefined
                            ? " *"
                            : ""),
                        "label-for": "input-cuota-tipo-cuota",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          name: "input-cuota-tipo-cuota",
                          id: "input-cuota-tipo-cuota",
                          required: _vm.cuota.frecuenciaOtraCuota != undefined,
                          state: !_vm.$v.cuota.tipoCuota.$invalid,
                          disabled: !_vm.esEscritura,
                        },
                        model: {
                          value: _vm.cuota.tipoCuota,
                          callback: function ($$v) {
                            _vm.$set(_vm.cuota, "tipoCuota", $$v)
                          },
                          expression: "cuota.tipoCuota",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$v.cuota.tipoCuota.required
                        ? _c("small", {
                            staticClass: "text-danger",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("entity.validation.required")
                              ),
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { md: "12" } }, [
            _c("div", { staticClass: "border-top mt-4 mb-4" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mb-5 float-right" },
              [
                _vm.esEscritura
                  ? _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          size: "md",
                          disabled: _vm.desactivarBoton,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.guardarCuota()
                          },
                        },
                      },
                      [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.$t("entity.action.save")),
                          },
                        }),
                        _vm._v(" "),
                        _c("font-awesome-icon", {
                          staticClass: "mr-2",
                          attrs: { icon: "save" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }